export default "__VITE_ASSET__CJjTYAN9__"